import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Button, Card, CardContent, Collapse, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { NeedsClusterRemovedDetailsDto } from 'dtos'
import { useState } from 'react'

interface VehicleClusterRemovedHeroCardProps {
  vehicle: NeedsClusterRemovedDetailsDto
}

export default function VehicleClusterRemovedHeroCard({ vehicle }: VehicleClusterRemovedHeroCardProps) {
  const [open, setOpen] = useState(false)

  const handleOpenClick = () => {
    setOpen(prev => !prev)
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container wrap='nowrap' alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container alignItems='center' spacing={0}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  {vehicle.vin}
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} sm='auto' container spacing={1}>
              <Grid item>
                <Button onClick={handleOpenClick}>{open ? <ExpandLess /> : <ExpandMore />}</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Collapse in={open} timeout='auto' unmountOnExit>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <LabelField label='Exporter' value={vehicle.exporterCompany?.name} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Year' value={vehicle.year} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Make' value={vehicle.make} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Model' value={vehicle.model} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Importer Stock #' value={vehicle.importerStockNumber} />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <GreenText variant='outlined'>
                    {`**Vehicle Information Card Accordion:**

Clicking the Vehicle Information card will expand the accordion displaying additional details about the vehicle.

**VIN:**

Displays the VIN (Vehicle Identification Number) associated with the vehicle.

**Exporter:**

Displays the Exporter Company associated with the vehicle.

**Year:**

Displays the year of manufacture for the vehicle.

**Make:**

Displays the make (manufacturer) of the vehicle.

**Model:**

Displays the model of the vehicle.

**Importer Stock Number:**

Displays the Importer Stock Number associated with the vehicle.`}
                  </GreenText>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
